import { transformUnits } from '@/helpers/unit-formatter/unit-formatter';
import { MPH_OUTPUT_LABEL } from '@/helpers/unit-formatter/unit-formatter.constants';
import { FormattedUnitLabels, UnitValue } from '@/helpers/unit-formatter/unit-formatter.types';
import {
  toNumber,
  unitValueToFormattedUnitLabels,
} from '@/helpers/unit-formatter/unit-formatter.utils';

/**
 * Formatter for wind speed values in miles per hour.
 * Clamps negative values to zero, rounds to the nearest integer, and displays the unit label as MPH.
 */
export const formatMph = (unitValue: UnitValue, displayUnits?: string): FormattedUnitLabels => {
  const transformed = transformUnits(unitValue, displayUnits);
  const value = toNumber(transformed.value);

  if (value == null) {
    return unitValueToFormattedUnitLabels({ value: transformed.value, units: undefined });
  }

  return unitValueToFormattedUnitLabels({
    value: Math.max(0, Math.round(value)),
    units: MPH_OUTPUT_LABEL,
  });
};
